/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_S4Inputs */

const en_tut_jadwal_s4 = /** @type {(inputs: Tut_Jadwal_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not want reminders? Turn off the **Pengingat rapat internal** group in **Settings → Notifikasi**.`)
};

const id_tut_jadwal_s4 = /** @type {(inputs: Tut_Jadwal_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ingin diingatkan? Matikan kelompok **Pengingat rapat internal** di **Settings → Notifikasi**.`)
};

/**
* | output |
* | --- |
* | "Do not want reminders? Turn off the **Pengingat rapat internal** group in **Settings → Notifikasi**." |
*
* @param {Tut_Jadwal_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_s4 = /** @type {((inputs?: Tut_Jadwal_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_s4(inputs)
	return en_tut_jadwal_s4(inputs)
});